import type { ReactNode } from "react";
import { DigestWidget } from "@/components/DigestWidget";
import { PublicHeader } from "@/components/public-layout";
import { VideoWidget } from "@/components/VideoWidget";

export function PublicPageLayout({ children }: { children: ReactNode }) {
	return (
		<div className="flex min-h-svh flex-col [overflow-x:clip] bg-background pt-[4.5rem] text-foreground">
			<PublicHeader />

			<div className="w-full px-4 sm:px-6">
				{/*
					Container context for the content column. Sponsors are now woven
					into the content (leaderboard rows, featured card, agent profiles)
					instead of fixed rails, so the column spans the full width.
					Descendants keep using `@.../page` container-query variants.
				*/}
				<div className="@container/page">{children}</div>
			</div>

			<DigestWidget />
			<VideoWidget />
		</div>
	);
}
